import React from "react";

const FarmIcon = ({ stroke }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1184_2602)">
        <path
          d="M13 2.16663C18.9833 2.16663 23.8334 7.01671 23.8334 13C23.8334 18.9832 18.9833 23.8333 13 23.8333C7.01677 23.8333 2.16669 18.9832 2.16669 13C2.16669 7.01671 7.01677 2.16663 13 2.16663ZM13 6.49996C12.7127 6.49996 12.4372 6.6141 12.234 6.81726C12.0308 7.02042 11.9167 7.29597 11.9167 7.58329V13C11.9167 13.2873 12.0309 13.5628 12.2341 13.7659L15.4841 17.0159C15.6884 17.2132 15.9621 17.3224 16.2461 17.3199C16.5302 17.3175 16.8019 17.2035 17.0027 17.0027C17.2036 16.8018 17.3175 16.5301 17.32 16.2461C17.3225 15.962 17.2133 15.6884 17.0159 15.484L14.0834 12.5515V7.58329C14.0834 7.29597 13.9692 7.02042 13.7661 6.81726C13.5629 6.6141 13.2873 6.49996 13 6.49996Z"
          fill="#797979"
        />
      </g>
      <defs>
        <clipPath id="clip0_1184_2602">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FarmIcon;
